
<template>
    <!-- 右侧价格指数 -->
    <div class="p15 bgWhite w100 price-index-ctrl">
        <h3><img src="../assets/images/jgzs.png" alt="" srcset=""> <router-link :to="navigationUrl['价格指数']" class="more pointer">更多+</router-link> </h3>

        <el-carousel :interval=10000>
            <!-- <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChart" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndex_list" :key="index">
                        <div>{{ item.indexName }}</div>
                        <div>{{ parseInt(item.higthPrice) }}</div>
                        <div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ parseInt(item.upDownNum) }}</div>
                        <div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ item.ringNum }}%</div>
                        <div style="flex: 2">{{ item.dataDate }}</div>
                    </div>
                </div>
            </el-carousel-item> -->
            <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChartJN" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndexJN_list" :key="index">
                        <div>{{ item.indexName }}</div>
                        <div>{{ parseInt(item.higthPrice) }}</div>
                        <div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ parseInt(item.upDownNum) }}</div>
                        <div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ item.ringNum }}%</div>
                        <div style="flex: 2">{{ item.dataDate }}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChartDG" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndexDG_list" :key="index">
                        <div>{{ item.nodeName ? item.nodeName : '带钢' }}</div>
                        <div>{{ parseInt(item.data) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
                        <div style="flex: 2">{{ item.rq }}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChartGP" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndexGP_list" :key="index">
                        <div>{{ item.nodeName ? item.nodeName : '钢坯' }}</div>
                        <div>{{ parseInt(item.data) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
                        <div style="flex: 2">{{ item.rq }}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChartJKK" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndexJKK_list" :key="index">
                        <div>{{ item.nodeName ? item.nodeName : '进口矿' }}</div>
                        <div>{{ parseInt(item.data) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
                        <div style="flex: 2">{{ item.rq }}</div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item class="w100" style="height: 400px;">
                <p ref="lineChartJT" style="height: 240px; width: 360px; margin-top: 10px"></p>
                <div class="mw-table-grid">
                    <div class="mw-table-row" v-for="(item, index) in priceIndexJT_list" :key="index">
                        <div>{{ item.nodeName ? item.nodeName : '焦炭' }}</div>
                        <div>{{ parseInt(item.data) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
                        <div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
                        <div style="flex: 2">{{ item.rq }}</div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>

        
    </div>
</template>

<script>
import $ from 'jquery'
import { baseUrl, navigationUrl } from '../assets/js/common'
import { LineOption } from '../assets/js/options'
export default {
    name: 'PriceIndexControl',
    components: { },
    data () {
        return {
            beginDate: '',
            endDate: '',
            priceIndex_list: [],
            priceIndexJN_list: [],
            priceIndexGP_list: [],
            priceIndexDG_list: [],
            priceIndexJKK_list: [],
            priceIndexJT_list: [],
            navigationUrl: navigationUrl,
        }
    },
    mounted () {
        // 初始化内容
        const date = new Date();
        this.beginDate = `${(date.getFullYear() - 1)}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}`; // 
        this.endDate = `${date.getFullYear()}-${date.getMonth() + 2 >= 10 ? date.getMonth() + 2 : ('0' + (date.getMonth() + 2))}`;
        this.beginDate1 = `${(date.getFullYear() - 1)}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}-${date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())}`; // 
        this.endDate1 = `${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}-${date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())}`;
        this.getNewsEveryDay();
        this.getIronNewsEveryDay();
        this.getNewsEveryDayDG(); 
        // this.getPriceIndexList();
        this.getPriceIndexListJN();
        this.getIndexDatasDG();
        this.getCokeNewsEveryDay();
    },
    methods: {
        //页面操作
        // 获取每日钢坯最新数据
        getNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/billetDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101`, {}).then(res => {
                if (res.code == 0) {
                     self.priceIndexGP_list = res.data;
                    self.getIndexDatas(res.data);
                } else {
                    self.GPIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋钢坯价格指数
        getIndexDatas (newsData) {
            // const self = this;
            // const option = new LineOption();
            // let min = 0;
            // let max = 0;
            // let seriesObj = {};
            // let lineChart = self.$echarts.init(self.$refs.lineChartGP); 
            // option.title.text = '唐宋钢坯价格指数';
            // self.$get(`${baseUrl.online}/industria/billetDataN/indexDatasEcharts?nodeId=pricnonobitcchnokrts&beginDate=${self.beginDate}&endDate=${self.endDate}`, {}).then(res => {
            //     if (res.code == 0) {
            //         const data = $.extend(true, [], res.data);
            //         res.data = res.data.reverse();
            //         seriesObj = {
            //             type: 'line',
            //             name: '',
            //             smooth: true,
            //             smoothMonotone: 'none',
            //             lineStyle: {
            //                 color: ''
            //             },
            //             data: []
            //         }
            //         seriesObj.lineStyle.color = '#e45d3e';
            //         seriesObj.name = newsData[0].nodeName ? newsData[0].nodeName : '钢坯'; 
            //         res.data.forEach((cItem, cIndex) => {
            //             seriesObj.data.push(cItem.data)
            //             max = cItem.data > max ? cItem.data : max;
            //             min = cIndex == 0 ? cItem.data : (cItem.data < min ? cItem.data : min); 
            //             option.xAxis.data.push(cItem.rq);
            //         })
            //         option.series.push(seriesObj);
            //         option.yAxis.min = min - 100;
            //         option.yAxis.max = Number(max) + 100;
            //         lineChart.setOption(option);

            //     } else {
            //         self.$message.error(res.message);
            //     }
            // }).catch(err => {
            //     // self.$message.error('获取指数错误')
            // })

            const self = this;
            const option = new LineOption();
            option.title.text = '唐宋钢坯价格指数';
            const params = {"param":[{"nodeId":"pricnonobitcchnokrts"},{"nodeId":"pricnonobitcchnokrjy"},{"nodeId":"pricnonobitcchnokrtste"}],"beginDate":self.beginDate,"endDate":self.endDate}
            
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartGP); 
            self.$post(`${baseUrl.online}/industria/billetDataN/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    // self.sortDates(data);
                    var x_val = self.getRQ3(data);
                    data.forEach((item, index) => {
                        var _data = [];
                        _data = self.getYAxis3(x_val, item.data);
                        seriesObj = {
                            type: 'line',
                            name: '',
                            connectNulls: true,
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: _data
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                if (cItem.nCode == 'pricnonobitcchnokrts') {
                                    seriesObj.name = '唐宋钢坯价格指数'; 
                                } else if (cItem.nCode == 'pricnonobitcchnokrjy') {
                                    seriesObj.name = '唐宋江阴钢坯现货指数'
                                } else if (cItem.nCode == 'pricnonobitcchnokrtste') {
                                    seriesObj.name = '唐宋唐山钢坯现货指数'
                                }
                            }
                        })
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            // seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            // if (index == 0) {
                            //     option.xAxis.data.push(cItem.rq);
                            // }
                        })
                            // console.log(seriesObj.name, option.xAxis.data)
                        
                        option.series.push(seriesObj);
                    })
                    // console.log(option.series)
                    // option.yAxis.min = min - 100;
                    option.xAxis.data = x_val;
                    option.yAxis.max = Number(max) + 1000;
                    // option.grid.top = 60;
                    lineChart.setOption(option, {notMerge: true});

                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },


        // 获取带钢最新数据
        getNewsEveryDayDG () {
            const self = this;
            self.$get(`${baseUrl.online}/indexData/indexDatas?cpage=1&pageSize=20&nodeId=0401`, {}).then(res => {
                if (res.code == 0) {
                     self.priceIndexDG_list = res.data;
                } else {
                    self.DGIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },

        // 获取唐宋带钢价格指数
        getIndexDatasDG () {
            const self = this;
            const option = new LineOption();
            option.title.text = '唐宋带钢价格指数';
            const params = {
                "param":[{"nodeId":"pricnonohstcchnokrts"}],
                "beginDate":self.beginDate,
                "endDate":self.endDate
            }
            
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartDG); 
            self.$post(`${baseUrl.online}/indexData/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '唐宋带钢价格指数',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    option.yAxis.min = min - 100;
                    option.yAxis.max = Number(max) + 1000;
                    option.grid.top = 60;
                    lineChart.setOption(option, {notMerge: true});

                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
           
        },



        // 获取进口矿每日最新数据
        getIronNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/ironOreIndexData/newIndexDatas?cpage=1&pageSize=20&nodeId=0301`, {}).then(res => {
                if (res.code == 0) {
                     self.priceIndexJKK_list = res.data;
                    self.getIndexDataCompare(res.data);
                } else {
                    self.JKKIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋进口矿价格指数
        getIndexDataCompare (newsData) {
            const self = this;
            const option = new LineOption();
            // const params = {"param":[{"nodeId":"pricnonoiofrchtakrqd013"},{"nodeId":"pricnonoiofrchtakrqd010"},{"nodeId":"pricnonoiofrchtakrqd009"},{"nodeId":"pricnonoiofrchtakrqd008"}],"beginDate": self.beginDate,"endDate": self.endDate}
            const params = {"param":[{"nodeId":"8FAE2F67663E8E5C810E575903511CC1"},{"nodeId":"FA7A861948BA6BA8E8AA364B1CDB069E"},{"nodeId":"B600B408E4335DF4DD50712922EE0A10"}],"beginDate": self.beginDate,"endDate": self.endDate}
            
            const indexDatasColor = ['#e7b483', '#86e6aa', '#e45d3e', '#d392ce'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJKK); 
            option.title.text = '唐宋进口矿价格指数';
            self.$post(`${baseUrl.online}/industria/ironOreIndexData/newIndexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                seriesObj.name = cItem.nodeName; 
                            }
                        })
                        if (index == 0) {
                            min = item.data[0]['data'];
                        }
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            if (Number(cItem.data) < Number(min)) {
                                min = cItem.data;
                            }

                            //min = index == 0 ? cItem.data : (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    option.grid.right = 40;
                    option.yAxis.min = min - 100;
                    option.yAxis.max = Number(max) + 1000;
                    lineChart.setOption(option);

                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },

        // 获取焦炭每日最新数据
        getCokeNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/cokeDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101`, {}).then(res => {
                if (res.code == 0) {
                    self.priceIndexJT_list = res.data;
                    self.getCokeDataCompare(res.data);
                } else {
                    self.JTIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋焦炭价格指数
        getCokeDataCompare (newsData) {
            const self = this;
            const option = new LineOption();
            // const params = {"param":[{"nodeId":"pricnonoiofrchtakrqd013"},{"nodeId":"pricnonoiofrchtakrqd010"},{"nodeId":"pricnonoiofrchtakrqd009"},{"nodeId":"pricnonoiofrchtakrqd008"}],"beginDate": self.beginDate,"endDate": self.endDate}
            const params = {"param":[{"nodeId":"pricnonocoyjchzbkrtsnoo"}],"beginDate": self.beginDate,"endDate": self.endDate}
            
            const indexDatasColor = ['#e7b483', '#86e6aa', '#e45d3e', '#d392ce'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJT); 
            option.title.text = '唐宋焦炭价格指数';
            self.$post(`${baseUrl.online}/cokeDataN/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                seriesObj.name = cItem.nodeName; 
                            }
                        })
                        if (index == 0) {
                            min = item.data[0]['data'];
                        }
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            if (Number(cItem.data) < Number(min)) {
                                min = cItem.data;
                            }

                            //min = index == 0 ? cItem.data : (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    option.grid.right = 40;
                    option.yAxis.min = min - 100;
                    option.yAxis.max = Number(max) + 1000;
                    lineChart.setOption(option);

                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },

        getYAxis3(xArr, list) {
            var len = xArr.length;
            var yAxis = new Array(len);
            var listLen = list.length;
            for(var i in xArr) {
                for(var j in list) {
                    if(list[j].rq == xArr[i]) {
                        yAxis[i] = list[j].data;
                        break;
                    }
                }
            }
            return yAxis;
        },
        getRQ3(data) {
            var rq = [];
            for(var i in data) {
                for(var j in data[i].data) {
                    rq.push(data[i].data[j].rq);
                }
            }
            rq.sort(function(a, b) {
                return Date.parse(b) - Date.parse(a);
            });
            var r = [];
            for(var i = 0, l = rq.length; i < l; i++) {
                for(var j = i + 1; j < l; j++)
                    if(rq[i] === rq[j]) j = ++i;
                r.push(rq[i]);
            }
            r = r.reverse();
            return r;
        },

        // 排列日期
        sortDates (data) {
            let maxLengthDate = data[0]['data'];
            data.forEach((item, index) => {
                if (item.data.length > 0) {
                    item.data = item.data.reverse();
                    if (index < data.length - 1) {
                        if (maxLengthDate.length < data[index + 1]['data'].length) {
                            maxLengthDate = data[index + 1]['data'];
                        }
                    }
                }
            })
            data.forEach((cItem, cIndex) => {
                if (cItem.data.length > 0) {
                    const itemDate = new Date(cItem.data[0].rq).getTime();
                    let pushDate = [];
                    maxLengthDate.forEach((dItem, dIndex) => {
                        const maxTime = new Date(dItem.rq).getTime();
                        if (itemDate > maxTime) {
                            const param = {
                                chg: null, data: null, dataNId: null, highest: null, lowest: null, nCode: null,
                                nodeName: null, operatorId: null, operatorTime: null, range: null, remark: null, rq: dItem, w: null
                            };
                            pushDate.push({})
                        }
                    })
                    cItem.data = pushDate.concat(cItem.data)
                }
            })
        },

        // 获取荣钢消防管指数数据
        getPriceIndexList () {
            const self = this;
            const option = new LineOption();
            const priceIndexCode = ['0D80920CA76E2CF8939884A478B2353D', '1106B08859E27769C876C3C98A8B0221', 'A1BE7FEC729F81E986B29C7B9FA573AB'];
            const priceIndexColor = ['#e45d3e', '#d392ce', '#e7b483'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChart); 
            option.title.text = '荣钢消防管价格指数';

            priceIndexCode.forEach((item, index) => {
                self.$get(`${baseUrl.online}/industria/priceIndex/list?groupCode=${item}&beginDate=${self.beginDate1}&endDate=${self.endDate1}`, {}).then(res => {
                    if (res.code == 0) {
                        const data = $.extend(true, [], res.data);
                        self.priceIndex_list.push(data[0]);
                        res.data = res.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = priceIndexColor[index];
                        seriesObj.name = res.data[0].indexName; 
                        res.data.forEach((cItem, cIndex) => {
                            seriesObj.data.push(cItem.higthPrice)
                            max = cItem.higthPrice > max ? cItem.higthPrice : max;
                            min = index == 0 ? cItem.higthPrice : (Number(cItem.higthPrice) < Number(min) ? cItem.higthPrice : min); 
                            if (index == 0) {
                                option.xAxis.data.push(cItem.dataDate);
                            }
                        })
                        option.series.push(seriesObj);
                        if (option.series.length == 3) {
                            option.yAxis.min = min - 100;
                            option.yAxis.max = Number(max) + 100;
                            lineChart.setOption(option);
                        }

                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    // self.$message.error('获取指数错误')
                })
            })
        },

        // 获取晋南钢铁指数
        getPriceIndexListJN () {
            const self = this;
            const option = new LineOption();
            const priceIndexCode = ['CDC3E0BA62984371B79285A23BE8DCA5', 'C8F123FC68DCFD08D853DF31E92A1069', '3744F8B8771AF0E2F77251875BCC5961', ' CFD649923841F6043E3D6C50EB15BD99'];
            const priceIndexColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJN); 
            option.title.text = '晋南钢铁价格';

            priceIndexCode.forEach((item, index) => {
                self.$get(`${baseUrl.online}/industria/priceIndex/list?groupCode=${item}&beginDate=${self.beginDate1}&endDate=${self.endDate1}`, {}).then(res => {
                    if (res.code == 0) {
                        const data = $.extend(true, [], res.data);
                        self.priceIndexJN_list.push(data[0]);
                        res.data = res.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = priceIndexColor[index];
                        seriesObj.name = res.data[0].indexName; 
                        res.data.forEach((cItem, cIndex) => {
                            seriesObj.data.push(cItem.higthPrice)
                            max = cItem.higthPrice > max ? cItem.higthPrice : max;
                            min = index == 0 ? cItem.higthPrice : (cItem.higthPrice < min ? cItem.higthPrice : min); 
                            if (index == 0) {
                                option.xAxis.data.push(cItem.dataDate);
                            }
                        })
                        option.series.push(seriesObj);
                        if (option.series.length == 4) {
                            option.yAxis.min = min - 100;
                            option.yAxis.max = Number(max) + 100;
                            lineChart.setOption(option);
                        }

                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    // self.$message.error('获取指数错误')
                })
            })
        },

        

        
    },
}
</script>

<style scoped>
    .price-index-ctrl { margin-bottom: 20px; box-sizing: border-box; height: 445px; }
    .more { float: right; }
</style>